export default __webpack_public_path__ + "static/media/Simple-Line-Icons4c82.51b9ac91.svg";